import { Component, OnInit } from '@angular/core';
import { AuthService } from '@services/auth.service';

@Component({
  template: `Logged out`,
  standalone: false,
})
export class LogoutComponent implements OnInit {
  constructor(private readonly authService: AuthService) {}

  ngOnInit() {
    this.authService.logoff();
  }
}

